import { PolicyDetails, PolicySummary } from "./types/PolicyExtended.types";

/**
 * Correlate active policies and their future policies
 */
export function populateFutureVersion<T extends PolicySummary | PolicyDetails>(
  issuedPolicies: T[],
  futurePolicies: T[]
): T[] {
  return issuedPolicies.map((policy) => {
    // Future versions of apex policies not supported yet
    if (policy.source === "APEX") {
      return policy;
    }

    const futureVersion = futurePolicies.find(
      (futurePolicy) =>
        futurePolicy.policyNumber.split("-")[0] ===
        policy.policyNumber.split("-")[0]
    );

    return {
      ...policy,
      futureVersion: futureVersion
        ? {
            policyNumber: futureVersion.policyNumber,
            effectiveDate: futureVersion.effectiveDate as string,
            expirationDate: futureVersion.expirationDate as string,
          }
        : undefined,
    };
  });
}
